export default __webpack_public_path__ + "static/media/sticker-or.079eb17d.png";